// extracted by mini-css-extract-plugin
export default {"root":"content-module--root--B2VPH"};